export enum TouchedType {
  Start,
  Move,
  End,
  Leave,
}
